// extracted by mini-css-extract-plugin
module.exports = {"style":"Table_style__2shIK","sorted":"Table_sorted__1XC-l"};